/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EExportExcelRequest = 'Month' | 'Quarter' | 'Year' | 'Custom';

export const EExportExcelRequest = {
    Month: 'Month' as EExportExcelRequest,
    Quarter: 'Quarter' as EExportExcelRequest,
    Year: 'Year' as EExportExcelRequest,
    Custom: 'Custom' as EExportExcelRequest
};

